import { render } from "./MengikutJenis.vue?vue&type=template&id=007a198a"
import script from "./MengikutJenis.vue?vue&type=script&lang=js"
export * from "./MengikutJenis.vue?vue&type=script&lang=js"

import "./MengikutJenis.vue?vue&type=style&index=0&id=007a198a&lang=css"
import "./MengikutJenis.vue?vue&type=style&index=1&id=007a198a&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__